import { AppRoute } from '@agentselly/immodossier-shared';
import { PropertyConditionsQualityFormWidget } from '~/components/widget/PropertyConditionsQualityFormWidget';
import { createFileRoute } from '@tanstack/react-router';
import { useLoaderQuery } from '~/helper/useLoaderQuery';
import { LoadingWidget } from '~/components/widget/base/LoadingWidget';
import { ErrorWidget } from '~/components/widget/base/ErrorWidget';
import { useAppParams } from '~/helper/useAppParams';

export const Route = createFileRoute(
  AppRoute.$LANG_$COMPANYID_$CONTACTID_DOSSIER_$DOSSIERID_PROPERTY_CONDITION_EDIT,
)({
  component: Body,
});

function Body() {
  const params = useAppParams(Route);

  const query = useLoaderQuery(
    AppRoute.$LANG_$COMPANYID_$CONTACTID_DOSSIER_$DOSSIERID_PROPERTY_CONDITION_EDIT,
    {
      params: params,
    },
  );

  if (query.isLoading) {
    return <LoadingWidget />;
  }

  if (query.isError || !query.data) {
    return <ErrorWidget error={query.error} />;
  }

  return <PropertyConditionsQualityFormWidget {...query.data?.widgetProps} />;
}
